"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function typesFromDefs(definitions, initTypes = {}) {
    return Object.values(definitions).reduce((res, { types }) => ({
        ...res,
        ...types
    }), initTypes);
}
exports.default = typesFromDefs;
